import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import tenantApi from '../../api/tenant/TenantApi'
import { TenantDto } from '../../api/tenant/models/TenantDto'
import { Pages } from '../../Pages'
import ToggleSwitch3 from '../ToggleSwitch3'

function TenantsTab(): React.JSX.Element {
    const [tenants, setTenants] = useState<TenantDto[]>([])
    const [showJobSeekers, setShowJobSeekers] = useState(false)

    useEffect(() => {
        const fetchTenants = async () => {
            const tenantData = await tenantApi.getAll({
                includePersonal: showJobSeekers,
            })
            setTenants(tenantData.tenants)
        }

        void fetchTenants()
    }, [showJobSeekers])

    return (
        <div>
            <div className="flex items-center justify-between">
                <h3 className="page-title">Tenants</h3>
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                        <span className="text-sm text-gray-600">
                            Show Job Seekers
                        </span>
                        <ToggleSwitch3
                            value={showJobSeekers}
                            onChange={setShowJobSeekers}
                        />
                    </div>
                    <Link
                        to={Pages.CreateNewTenant}
                        className="flex items-center justify-center w-12 h-12 rounded-full bg-[#153bab] text-white text-xl font-bold border-none no-underline cursor-pointer relative transition-all duration-300 ease shadow-md overflow-hidden group hover:w-40 hover:h-12 hover:rounded-[25px] hover:bg-blue-600"
                    >
                        <span className="opacity-100 transition-opacity duration-300 group-hover:opacity-0">
                            +
                        </span>
                        <span className="absolute whitespace-nowrap text-base opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                            Add New Tenant
                        </span>
                    </Link>
                </div>
            </div>
            <table className="main-table w-full">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                    </tr>
                </thead>
                <tbody>
                    {tenants.map((tenant) => (
                        <tr key={tenant.id}>
                            <td>{tenant.id}</td>
                            <td>
                                <Link
                                    className="link-text"
                                    to={`${Pages.Tenant}?id=${tenant.id}`}
                                >
                                    {tenant.name}
                                </Link>
                                {tenant.isPersonal && (
                                    <span className="ml-2 px-2 py-0.5 text-xs font-medium rounded-full bg-amber-100 text-amber-700">
                                        Job Seeker
                                    </span>
                                )}
                            </td>
                        </tr>
                    ))}
                    {tenants.length === 0 && (
                        <tr>
                            <td
                                colSpan={2}
                                className="text-center text-sm text-gray-500"
                            >
                                No tenants yet.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default TenantsTab
